import axios from 'axios';

export const getEmailValidityStatuses = async (url, emails) => {
    try {
        const { data } = await axios.post(url, { recipients: emails });

        return data;
    } catch (error) {
        throw new Error('Could not get the email status from Recipient Risk Service.');
    }
};

export const EMAIL_RRS_INVALID_REASONS = ['FORMAT_INVALID', 'INVALID_TLD'];
